/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { Grid } from "@material-ui/core";

import useStyles from "./styles";
import RemoveIcon from "@material-ui/icons/Remove";
import AddIcon from "@material-ui/icons/Add";

const GroupedButtons = props => {
	const classes = useStyles();
	const { productId, handleCountProduct, quantity } = props;
	const [count, setCount] = useState(0);

	useEffect(() => {
		if (quantity) {
			setCount(quantity);
		}
	}, []);

	const handleBtnMinus = () => {
		if (count > 0) {
			setCount(count - 1);
		}
	};

	const handleBtnPlus = () => {
		setCount(count + 1);
	};

	useEffect(() => {
		handleCountProduct(productId, count);
	}, [count]);

	return (
		<Grid classes={{ root: classes.root }}>
			<Grid
				classes={{ root: classes.btnDefault }}
				component="button"
				disabled={count === 0}
				onClick={() => handleBtnMinus()}
			>
				<RemoveIcon />
			</Grid>
			<Grid classes={{ root: classes.textValue }}>{count}</Grid>
			<Grid
				classes={{ root: classes.btnDefault }}
				component="button"
				onClick={() => handleBtnPlus()}
			>
				<AddIcon />
			</Grid>
		</Grid>
	);
};

export default GroupedButtons;
